import React, { useContext, useState } from "react";
import { AppContext, AuthContext } from "App";
import DeviceCategory from "./components/DeviceCategory";
import SearchInput from "./components/SearchInput";

export default function DeviceList(props) {
  const auth = useContext(AuthContext);
  const appContext = useContext(AppContext);

  return (
    <div>
      <SearchInput filter={props.filter} setFilter={props.setFilter} />
      {Object.keys(props.groupedDevices).map((category) => (
        <DeviceCategory
          key={category}
          category={category}
          devices={props.groupedDevices[category]}
          filter={props.filter}
          calculateBounds={props.calculateBounds}
          setMapCenter={props.setMapCenter}
          setMapZoom={props.setMapZoom}
          setCalcZoom={props.setCalcZoom}
          selectedDevices={props.selectedDevices}
          toggleDevice={props.toggleDevice}
          handleSave={props.handleSave}
          saveSuccess={props.saveSuccess}
          auth={auth}
          setLoginPopupOpen={props.setLoginPopupOpen}
          triggerLoginOpen={props.triggerLoginOpen}
          showSettingsState={props.showSettingsState}
          selectedGroup={props.selectedGroup}
          setSelectedGroup={props.setSelectedGroup}
          {...props}
        />
      ))}
    </div>
  );
}
